import { AFI_THRESHOLDS } from '@leopart/calc';
import { AfiClass, AFIAlertType } from '../../models/afi';
import { IAuthContext } from '../../providers/authProvider';

// ── Classi AFI ───────────────────────────────────────────────────────────────

export const AFI_CLASSES: Record<AfiClass, { label: string; color: string; bg: string; borderColor: string }> = {
  antifragile: { label: 'Antifragile', color: '#1a7a4a', bg: '#e6f4ed', borderColor: '#34a868' },
  resilient:   { label: 'Resiliente',  color: '#0369a1', bg: '#e0f2fe', borderColor: '#38bdf8' },
  fragile:     { label: 'Fragile',     color: '#b45309', bg: '#fef3c7', borderColor: '#fbbf24' },
  critical:    { label: 'Critico',     color: '#991b1b', bg: '#fee2e2', borderColor: '#f87171' },
};

// ── Soglie score → classe ─────────────────────────────────────────────────────

export function getAFIClass(score: number): AfiClass {
  // Soglie centralizzate in @leopart/calc (AFI_THRESHOLDS).
  if (score >= AFI_THRESHOLDS.antifragile) return 'antifragile';
  if (score >= AFI_THRESHOLDS.resilient) return 'resilient';
  if (score >= AFI_THRESHOLDS.fragile) return 'fragile';
  return 'critical';
}

export function getAFIColor(score: number): string {
  return AFI_CLASSES[getAFIClass(score)].color;
}

export function getAFIBg(score: number): string {
  return AFI_CLASSES[getAFIClass(score)].bg;
}

export function getAFILabel(score: number): string {
  return AFI_CLASSES[getAFIClass(score)].label;
}

// ── Componenti ────────────────────────────────────────────────────────────────

export const AFI_COMPONENT_LABELS: Record<'A' | 'B' | 'C', string> = {
  A: 'Stabilità Fisiologica',
  B: 'Capacità Recovery',
  C: 'Margine Strutturale',
};

// ── Alert type → label ────────────────────────────────────────────────────────

export const AFI_ALERT_LABELS: Record<AFIAlertType, string> = {
  trend_negativo:         'Trend negativo',
  alert_fragilita:        'Alert fragilità',
  instabilita_prolungata: 'Instabilità prolungata',
  trend_positivo:         'Trend positivo',
  recovery_eccellente:    'Recovery eccellente',
  recovery_lento:         'Recovery lento',
  dati_insufficienti:     'Dati insufficienti',
};

export const AFI_ALERT_SEVERITY_COLORS: Record<string, string> = {
  info:     '#0369a1',
  warning:  '#b45309',
  critical: '#991b1b',
};

// ── Permessi per ruolo ─────────────────────────────────────────────────────────

export const AFI_PERMISSIONS = {
  canViewComponentA:       (ctx: IAuthContext) => ctx.isAdmin || ctx.isDirector,
  canViewComponentB:       (ctx: IAuthContext) => ctx.isAdmin,
  canViewComponentC:       (ctx: IAuthContext) => ctx.isAdmin || ctx.isDirector,
  canViewRawHRV:           (ctx: IAuthContext) => ctx.isAdmin,
  canViewAllNotifications: (ctx: IAuthContext) => ctx.isAdmin || ctx.isDirector,
} as const;
